import moment from 'moment-timezone';
import React, { Fragment, useState } from 'react';

import { Button } from '@sumologic/yama-ds-components';

import { Calendar } from 'shared/components/form/Calendar';
import { Time } from 'shared/components/form/Time';
import { getDateWithinTimezone } from 'shared/utils/date';

import css from './RecordSearchDateRangeSelect.module.scss';
import { RecordSearchDateRangeValue } from './types';

interface RecordsSearchCustomRangeSelectProps {
  minDate?: Date;
  onDeactivate: () => void;
  onSelectValue: (value: RecordSearchDateRangeValue) => void;
  selectedValue: RecordSearchDateRangeValue;
}

export const RecordsSearchCustomRangeSelect = ({
  minDate,
  onDeactivate,
  onSelectValue,
  selectedValue,
}: RecordsSearchCustomRangeSelectProps) => {
  const [customDateRange, setCustomDateRange] = useState<
    [Date | undefined, Date | undefined]
  >(
    typeof selectedValue === 'string'
      ? [moment().subtract(1, 'day').toDate(), new Date()]
      : selectedValue
  );

  return (
    <Fragment>
      <Calendar
        active={customDateRange[0]}
        activeEnd={customDateRange[1]}
        className={css.calendarContainer}
        isRange={true}
        maxDate={new Date()}
        minDate={minDate}
        onChange={(event) =>
          setCustomDateRange([event.startDate, event.endDate])
        }
        showToday={false}
      />
      <div className={css.timeContainer}>
        <div className={css.startTime}>
          <div className={css.dateLabel}>
            {customDateRange[0] &&
              getDateWithinTimezone(customDateRange[0]).toLocaleDateString()}
          </div>
          <div className={css.timeComponentContainer}>
            <Time
              active={customDateRange[0]}
              disabled={!customDateRange[0]}
              includeSeconds={true}
              isMilitary={false}
              onChange={(time) =>
                setCustomDateRange([time, customDateRange[1]])
              }
            />
          </div>
        </div>
        <div className={css.timeDivider}>TO</div>
        <div className={css.endTime}>
          <div className={css.dateLabel}>
            {customDateRange[1] &&
              getDateWithinTimezone(customDateRange[1]).toLocaleDateString()}
          </div>
          <div className={css.timeComponentContainer}>
            <Time
              active={customDateRange[1]}
              disabled={!customDateRange[1]}
              includeSeconds={true}
              isMilitary={false}
              onChange={(time) =>
                setCustomDateRange([customDateRange[0], time])
              }
            />
          </div>
        </div>
      </div>
      <div className={css.applyButtonContainer}>
        <Button
          disabled={!customDateRange[0] || !customDateRange[1]}
          onClick={() => {
            onDeactivate();
            onSelectValue([customDateRange[0]!, customDateRange[1]!]);
          }}
        >
          Apply
        </Button>
      </div>
    </Fragment>
  );
};
